import React, { useEffect, useState } from "react";
import { Outlet, useLocation, Navigate, matchPath } from "react-router-dom";

const ReturnPath = ({ primaryPath }: { primaryPath: string; }) => {
	const location = useLocation();

	const [ savedSearches, setSavedSearches ] = useState<Record<string, string>>({});

	const pathsToWatch = [ primaryPath ].filter(Boolean) as string[];

	const activePath = pathsToWatch.find((p) => matchPath({ path: `/view/${p}`, end: true }, location.pathname));

	useEffect(() => {
		// Every time the URL changes AND we are on the main page::
		// Save the new parameters
		if (activePath && location.search) {
			setSavedSearches((prev) => ({
				...prev,
				[activePath]: location.search,
			}));
		}
	}, [ location.search, location.pathname, activePath ]);

	// Redirect logic: if you navigate to the primary path (without search) but we have a saved search
	if (activePath && !location.search && savedSearches[activePath]) {
		return <Navigate to={`/view/${activePath}${savedSearches[activePath]}`} replace />;
	}

	return (
		<Outlet
			context={{
				primaryReturnPath: `/view/${primaryPath}${savedSearches[primaryPath] || ""}`,
			}}
		/>
	);
};

export default ReturnPath;
